import React from 'react';
import background from '../../assets/sea-otter.jpg';
import ReusableInfoCard from '../../components/ReusableInfoCard/ReusableInfoCard';


class InfoSeaotter extends React.Component {
  render () { 
   return(
  
  <ReusableInfoCard             
    
        tag="OCEANS"
        subtag="THREATENED"
        description="Sea Otters"
        paragraph="As top predators, sea otters are critical to maintaining the balance of nearshore ecosystems, such as kelp forests, embayments and estuaries. Pollution, fishing, and temperature rise are threatening their habitat."
        background={background}
     />
  
  );
 }
}   

export default InfoSeaotter;